<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
    <section class="container admin-dashboard-parent copy-editor-container">
        <section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Mail Rules'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
                <h1>Mail Rules</h1>
                <input type="submit" value="Add New" class="add-new-btn" (click)="addNew()">
			</div>
		</section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
        <section class="all-users-data">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-borderless table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Template Name</th>
                            <th scope="col">Purpose</th>
                            <th scope="col">Subject</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of list; let i = index;">
                            <tr class="body-header" (click)="toggleSection(i)">
                                <td>{{item.name}}</td>
                                <td>{{item.purpose}}</td>
                                <td>{{item.subject}}</td>
                            </tr>
                            <tr class="body-body" [ngClass]="{'hide':!lineState[i],'expanded':lineState[i]}">
                                <td colspan="3">
                                    <label>
                                        <span class="label">Template Name:</span>
                                        <input type="text" [(ngModel)]="list[i].name">
                                    </label><br>
                                    <label>
                                        <span class="label">Purpose:</span>
                                        <input type="text" [(ngModel)]="list[i].purpose">
                                    </label><br>
                                    <label>
                                        <span class="label">Subject:</span>
                                        <input type="text" [(ngModel)]="list[i].subject">
                                    </label><br>
                                    <label>
                                        <span class="label">Rule:</span>
                                        <input type="text" [(ngModel)]="list[i].rule">
                                    </label><br>
                                    <label>
                                        <span class="label">Template Body:</span><br>
                                        <textarea [(ngModel)]="list[i].body"></textarea>
                                    </label><br>
                                    <input type="submit" value="Save" (click)="saveItem(i)">
                                    <input type="button" value="Delete" (click)="deleteItem(i)">
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="pagination-controls-container">
                <app-pagination [currentPage]="page" [totalPages]="totalPages"
                    (pageChange)="loadUsers($event)" [section]="'mail_rules'"></app-pagination>
            </div>
        </section>
    </section>
</section>